//Parsiraj URL number parametre, sa fallback-om na defaultMin/max
export const parseNumberParam = (
  searchParams: any,
  key: string,
  fallback: number
): number => {
  const raw = searchParams.get(key);
  const n = raw !== null ? Number(raw) : NaN;
  return !isNaN(n) ? n : fallback;
};
